import getOr from "lodash/fp/getOr";
import { convertMarkdownToHTML } from "../utils/utils";

export class RegulationTariff {
  constructor(name, description, docs) {
    this.name = name;
    this.description = description;
    this.docs = docs;
  }

  genHtml(maximumItem) {
    let translate = window.searchData.destination === "NO" ? ' class="translate"' : "";

    let result = "";
    this.docs.sort((a, b) => {
      if (a.selected && !b.selected) return -1;
      if (!a.selected && b.selected) return 1;
      return 0;
    });
    this.docs.forEach((element, index) => {
      if (maximumItem === undefined || index < maximumItem) {
        result += `<tr class="item ${element.selected ? "selected" : "unselected"}">
            <td${translate}>${element.name}</td$>
            <td>
              <span class="showmore-element" data-config='{ "type": "text", "limit": 120, "more": "→ show more", "less": "← less" }'>${convertMarkdownToHTML(element.description)}</span>
            </td>
          </tr>`
      }
      if (maximumItem > 0 && index === maximumItem - 1) {
        result += `<tr class="item blur">
            <td${translate}>${element.name}</td$>
            <td>
              <span class="showmore-element" data-config='{ "type": "text", "limit": 120, "more": "→ show more", "less": "← less" }'>${convertMarkdownToHTML(element.description)}</span>
            </td>
          </tr>`
      }
    });

    return result;
  }

  static fromApiObject(input) {
    if (typeof (input) === "object" && input !== null) {
      const name = getOr("", "name")(input);
      const description = getOr("", "description")(input);
      const docs = getOr([], "docs")(input);
      return new RegulationTariff(
        name,
        description,
        docs
      );
    }
    return new RegulationTariff();
  }

  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map((item, index) => RegulationTariff.fromApiObject(item));
    }
    if (typeof (input) === "object" && input !== null) {
      return [RegulationTariff.fromApiObject(input)];
    }
    return [];
  }
}